import React, { useEffect, useState } from 'react'
import Select from "react-select";
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { debugLogPages } from '../../app/helpers/debugHelper';
import TableVerticalTechnology from './TableVerticalTechnology';
import { startRegisterCompareResult } from '../../app/actions/compareResultActions';

const ComparisonContainerTechnologyByField = () => {

  debugLogPages(':: ComparisonContainerTechnologyByField');

  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { technologiesS } = useSelector((state) => state.technology);

  const { listFieldsTechnology } = useSelector((state) => state.moduleConfig);
  const { comparisonTechnologyComboEnabled } = useSelector((state) => state.configuration);
  const [listFieldsToCompare, setListFieldsToCompare] = useState();
  const [selectedField, setSelectedField] = useState()

  useEffect(() => {
    let listFieldsToCompareT = [];
    listFieldsTechnology.forEach(element => {
      
      if (element.is_comparable) {
        
        listFieldsToCompareT.push(element);
      }
    });
    setListFieldsToCompare(listFieldsToCompareT);
  }, [])

  const handleChangeSelectCompare = (event) => {

    if (event != null) {
      setSelectedField(event);

      let selectedIds = "";
      let countIds = 0;
      for (let index = 0; index < technologiesS.length; index++) {
        if (technologiesS[index].isSelected) {
          technologiesS[index].isCompared = true;

          if (countIds === 0) {
              selectedIds = selectedIds.concat(technologiesS[index].id);
            } else {
              selectedIds = selectedIds.concat(";", technologiesS[index].id);
            }

            countIds++;

        }else{
          technologiesS[index].isCompared = false;
        }
      }

      const objectCompare = {
        deleted:false,
        compare_ids:selectedIds,
        total_selected:countIds,
        selected_field:event.field,
        is_compare_all_fields:false
      }
      dispatch(startRegisterCompareResult(objectCompare));


    } else {
      setSelectedField(null);
    }
  };


  return (
    <div>

      <div className="flexbox-title">
         <h2>{t("general.compare-technology")}</h2>
      </div>

      <br />

      {
        comparisonTechnologyComboEnabled === "true" &&
        <div>
          <Select
            myFontSize="14px"
            onChange={(event) => handleChangeSelectCompare(event)}
            className={`basic-single form-control`}
            classNamePrefix="select"
            name="texto"
            options={listFieldsToCompare}
            getOptionLabel={(option) => t(`${option.module_text}.synthetic.${option.field}`)}
            getOptionValue={(option) => `${option}`}
            isClearable={true}
            isSearchable={true}
            placeholder="Seleccione un Campo para comparar"
          />

          {selectedField && selectedField.field &&
            (<TableVerticalTechnology selectedField={selectedField} data={technologiesS} />)
          }

        </div>
      }

      <br />

    </div>
  )
}

export default ComparisonContainerTechnologyByField